var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCreditCard5Bea610844(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 24.76H5.75A3.76 3.76 0 0 1 2 21V9a3.76 3.76 0 0 1 3.75-3.76h18.5A3.76 3.76 0 0 1 28 9v12a3.76 3.76 0 0 1-3.75 3.76zm-18.5-18A2.25 2.25 0 0 0 3.51 9v12a2.25 2.25 0 0 0 2.24 2.24h18.5A2.25 2.25 0 0 0 26.49 21V9a2.25 2.25 0 0 0-2.24-2.24zm.76 3.19H23.5v1.5H6.51z",
    fill: "#231f20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.49 14.26h4v4h-4z",
    fill: "#1c54d6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51 14.25h7.04v1.5H6.51z",
    fill: "#231f20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditCard5Bea610844);
export default __webpack_public_path__ + "static/media/icon_credit_Card_5bea610844.e9a50aae732aa186c376d09eab6f7273.svg";
export { ForwardRef as ReactComponent };